var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { gql } from '@apollo/client/core';
import * as Report from './Report';
const FETCH_LOOKER_REPORT = gql `
  query LookerReports($reportId: String!) {
    app {
      lookerReportLink(reportId: $reportId)
    }
  }
`;
const FETCH_ALL_REPORTS = gql `
  query LookerReports {
    app {
      lookerReports {
        name
        reportId
      }
    }
  }
`;
export const fetchSelectedReportLink = (client, reportId) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield client.query({
        query: FETCH_LOOKER_REPORT,
        variables: { reportId },
        fetchPolicy: 'network-only',
    });
    if (!data.app.lookerReportLink) {
        throw Error('Error fetching report');
    }
    return data.app.lookerReportLink;
});
export const fetchAllReports = (client) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield client.query({
        query: FETCH_ALL_REPORTS,
    });
    if (!data.app.lookerReports) {
        throw Error('Error fetching reports');
    }
    return Report.fromGqlCollection(data.app.lookerReports);
});
//# sourceMappingURL=Api.js.map